import React from 'react';
import { AccountDropdownLinksWrapper } from './styles';
import ManageAccountLink from './ManageAccountLink';
import { useAccountDropdownContext } from './AccountDropdownProvider';
import { useAccountDropdownBundle } from '../../../../providers/PantherLocalizationProvider';

export const IA2AccountDropdownFooterLinks: React.VFC = () => {
  const { currentEntityId } = useAccountDropdownContext();
  const bundle = useAccountDropdownBundle();
  const managerAccountDiscoveryLink = `/am/managerAccounts/list?entityId=${currentEntityId}&ref_=AAC_unav_discovery_account_dropdown`;

  return (
    <AccountDropdownLinksWrapper>
      <ManageAccountLink
        label={bundle.getMessage('account-dropdown-manage-accounts-link-label')}
        url={`/accounts?entityId=${currentEntityId}&ref_=AAC_unav_manageaccounts`}
        e2eId="aac-account-management"
        data-takt-id="manager-account-link"
      />
      <ManageAccountLink
        label={bundle.getMessage(
          'account-dropdown-create-manager-account-label',
        )}
        url={managerAccountDiscoveryLink}
        data-takt-id="ccx-master-account-discovery-link"
        e2eId="aac-master-account-discovery-link"
      />
    </AccountDropdownLinksWrapper>
  );
};
